import { render } from "./certification.vue?vue&type=template&id=19499d99"
import script from "./certification.vue?vue&type=script&lang=js"
export * from "./certification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__